import { api } from "@/modules/api";

const DEFAULT_RETRANSCRIBE_ERROR_MESSAGE = "Retranscribe request failed. Please try again.";

type RetranscribeVoiceSourceArgs = {
  capturedAudioId: string;
};

type RetranscribeVoiceSourceResult = { success: true } | { success: false; errorMessage: string };

const extractRetranscribeErrorMessage = (rawError: unknown): string => {
  if (!rawError || typeof rawError !== "object") {
    return DEFAULT_RETRANSCRIBE_ERROR_MESSAGE;
  }

  const errorWithMessage = rawError as { error_message?: unknown; detail?: unknown };

  if (typeof errorWithMessage.error_message === "string") {
    return errorWithMessage.error_message;
  }

  if (typeof errorWithMessage.detail === "string") {
    return errorWithMessage.detail;
  }

  return DEFAULT_RETRANSCRIBE_ERROR_MESSAGE;
};

export const retranscribeVoiceSource = async ({
  capturedAudioId,
}: RetranscribeVoiceSourceArgs): Promise<RetranscribeVoiceSourceResult> => {
  const response = await api.post("/v2/voice/transcribe", {
    body: {
      captured_audio_id: capturedAudioId,
      force: true,
    },
  });

  if (!response.response.ok) {
    return {
      success: false,
      errorMessage: extractRetranscribeErrorMessage(response.error),
    };
  }

  return { success: true };
};

export const getRetranscribeErrorMessageFromUnknown = (error: unknown): string => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  return extractRetranscribeErrorMessage(error);
};

export { DEFAULT_RETRANSCRIBE_ERROR_MESSAGE };
